import PlusBold from './PlusBold';

export default PlusBold;
